module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Pictures2-486167467fef086ac377d3957334e53a.svg";